const CreateRequestTypes = type => {
  let data = {};
  let typesOfCalls = ['FETCH', 'SUCCESS', 'FAILURE'];
  typesOfCalls.map(item => {
    const key = type + '_' + item;
    Object.assign(data, {
      [key]: key,
    });
  });
  return data;
};

export default CreateRequestTypes;
